import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setToastStore } from './api'
import { useToastStore } from './stores/toast'
import './assets/styles/main.scss'
import * as Sentry from '@sentry/vue'

const app = createApp(App)
const pinia = createPinia()

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://45630639458285fe82d60258d13a76fb@sentry.nevisoft.com.tr/8',
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || 'insight-mobile@1.0.0',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/console\.weaccess\.ai/,
      /^https:\/\/app\.weaccess\.ai/
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Logs
    enableLogs: true
  })
}

app.use(pinia)
app.use(router)

// Toast store'u API interceptor'a bağla
const toastStore = useToastStore()
setToastStore(toastStore)

app.mount('#app')

// ─── Sentry test yardımcıları (PROD + DEV) ────────────────────────────────
window.sentryTest = {
  /** Manuel exception gönder */
  testError () {
    Sentry.captureException(new Error('Manuel Sentry test hatası - insight-mobile'))
    console.info('[Sentry] captureException gönderildi.')
  },
  /** Yakalanmamış hata fırlat (otomatik yakalanır) */
  testUnhandled () {
    // eslint-disable-next-line no-undef
    myUndefinedFunction()
  },
  /** Metric counter gönder */
  testMetrics () {
    Sentry.metrics.count('test_counter', 1, { tags: { env: import.meta.env.MODE } })
    console.info('[Sentry] metrics.count gönderildi: test_counter=1')
  },
  /** Tüm testleri çalıştır */
  runAll () {
    this.testMetrics()
    this.testError()
    console.info('[Sentry] Tüm testler çalıştırıldı. testUnhandled() ayrıca denenebilir.')
  }
}

console.info(
  '%c[Sentry] Test yardımcıları hazır',
  'color: #7B5EA7; font-weight: bold',
  '\n  sentryTest.testError()     → captureException',
  '\n  sentryTest.testUnhandled() → yakalanmamış ReferenceError',
  '\n  sentryTest.testMetrics()   → metrics.count',
  '\n  sentryTest.runAll()        → hepsini çalıştır'
)
